import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 2.4rem 0 1.2rem;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  gap: 1.2rem;
`;

export const Link = styled.a`
  text-decoration: none;
  color: inherit;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.2rem;
  padding: 1.6rem 1.2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
`;

export const Avatar = styled.div<{ $accent: string }>`
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 50%;
  background-color: ${({ $accent }) => $accent};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.6rem;
`;

export const Name = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const Role = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const Stars = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.amber};
  margin-top: 0.4rem;
`;

export const Count = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateMuted};
`;
